import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LockScreen from './components/LockScreen';
import UserSelect from './components/UserSelect';
import MainLayout from './components/MainLayout';
import BlogPost from './components/BlogPost';
import './App.css';

function App() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [selectedPersona, setSelectedPersona] = useState(null);

  const handleLock = () => {
    setIsUnlocked(false);
    setSelectedPersona(null);
  };

  const handleSwitchPersona = () => {
    setSelectedPersona(null);
  };



  return (
    <Router>
      <div className="App">
        {!isUnlocked ? (
          <LockScreen onUnlock={() => setIsUnlocked(true)} />
        ) : !selectedPersona ? (
          <UserSelect onSelectPersona={(persona) => setSelectedPersona(persona)} />
        ) : (
          <Routes>
            <Route path="/" element={<MainLayout persona={selectedPersona} onSwitchPersona={handleSwitchPersona} onLock={handleLock} />} />
            <Route path="/blog/:slug" element={<BlogPost persona={selectedPersona} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
